import React from 'react';
import {Grid, Box, Button, Typography} from "@deere/fuel-react";
import {useHistory} from "react-router-dom";
import {NO_PAGE_FOUND_TITLE, NO_PAGE_FOUND_DESC} from "./Constants";

export const NotFoundPage = ({backPage}) => {
    let history = useHistory();
    const goBack = () => history.replace(`/${backPage}`);

    return (
        <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <Typography size="4xl" fontWeight="semibold" component="p" gutterBottom>
                        {NO_PAGE_FOUND_TITLE}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <svg focusable="false" aria-hidden="true" fill="#666666" xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24" viewBox="0 0 24 24" style={{width: "200px", height: "200px"}}>
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                    </svg>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center" mb={8}>
                    <Typography size="xl" component="p" gutterBottom>
                        {NO_PAGE_FOUND_DESC}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} md={4}/>
            <Grid item xs={12} md={4}>
                <Box display="flex" justifyContent="space-around" alignItems="space-around">
                    <Button variant="primary" size="large" onClick={() => {
                        goBack()
                    }}>Back Home</Button>
                </Box>
            </Grid>
            <Grid item xs={12} md={4}/>
        </Grid>
    );
};
